import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=e30580d6&scoped=true"
import script from "./CourseIndex.vue?vue&type=script&lang=js"
export * from "./CourseIndex.vue?vue&type=script&lang=js"
import style0 from "./CourseIndex.vue?vue&type=style&index=0&id=e30580d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30580d6",
  null
  
)

export default component.exports